import { render, staticRenderFns } from "./DialogformfpgFcontinue.vue?vue&type=template&id=563e784f&"
import script from "./DialogformfpgFcontinue.vue?vue&type=script&lang=js&"
export * from "./DialogformfpgFcontinue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports